import { Action, any, IOWidget, onlyIf } from 'widgets-for-react'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { BlockData } from '../../cms/blocks/types.gen'
import { CustomBlockData, isCustomBlockData, renderCustomBlock } from './custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { getMockedBlockRenderer, BlocksRenderer, renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { postOverview } from '../templates/post_overview.mod'
import { publicationLibrary } from '../templates/PublicationLibrary/publicationLibrary.widget'
import { eventOverviewWidget } from '../custom_pages/even_overview_page/eventOverview.widget'
import { ArticlesOverviewWidget } from '../templates/ArticlesOverview/ArticlesOverview.widget'
import { WebinarsOverviewWidget } from '../custom_pages/Webinars/webinars.widget'
import { VideosOverviewWidget } from '../templates/VideosOverview/VideosOverview.widget'
import { ConferencesOverviewWidget } from '../custom_pages/Conferences/conferences.widget'
import { relatedArticles } from '../templates/relatedArticles'
import { fromJSX } from '../../../utils'

export let blocks_renderer = <customBlockData, extra_images, customPageData>() => ({
  ...getMockedBlockRenderer<customBlockData, extra_images, customPageData>()
  // featuredContentComponent:myFeauredContentBlock
})

export function pageDisplay_AUX(
  blocks: (Block | CustomBlock)[],
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  public_state: PublicSiteState
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return s => {

    const render_block = (b: CustomBlockData | BlockData<CustomBlockData, ExtraImages>, index: number) =>
      isCustomBlockData(b)
        ? renderCustomBlock(b, public_state, `key-${index}`)(s).map<
          Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
        >(a => s1 => {
          let res = a(s1)
          return { ...s1, images: res.images, blocks: res.blocks, custom_page_data: res.custom_page_data }
        })
        : renderBlock(b, blocks_renderer, `key-${index}`)(s).map<
          Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
        >(a => s1 => {
          let res = a(s1)
          return { ...s1, images: res.images, blocks: res.blocks }
        })

    let header = s.blocks.find(b => b.kind == 'headerBlock')
    s.custom_page_data.v.kind == 'r' && s.custom_page_data.v.v.post.type == 'conference' && s.custom_page_data.v.v.post.acf
    if (s.page.kind == 'loaded' &&
      s.page.value.extra_data.post.type == 'page' &&
      (s.page.value.extra_data.post.template == 'news-overview')) {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        postOverview(s.page.value, s.page.value.extra_data.post.template == 'news-overview' ? 'news' : 'story'),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }
    const page = s.page
    if (page.kind == 'loaded' &&
      page.value.extra_data.post.type == 'article') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray(),
        fromJSX(()  =>relatedArticles(page.value))
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' && s.page.value.extra_data.post.template == 'articles-overview') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        ArticlesOverviewWidget(s.articles_overview).map(a => s => ({ ...s, articles_overview: a(s.articles_overview) })),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' && s.page.value.extra_data.post.template == 'videos-overview') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        VideosOverviewWidget(s.videos_overview).map(a => s => ({ ...s, videos_overview: a(s.videos_overview) })),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' && s.page.value.extra_data.post.template == 'events-overview') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        eventOverviewWidget(s.event_overview_page).map(a => s => ({ ...s, event_overview_page: a(s.event_overview_page) })),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'conference') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        // conferenceInfoWidget(s.page.value.extra_data.post.acf).never(),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' &&
      s.page.value.extra_data.post.template == 'publication-library') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        publicationLibrary(s).map(a => s1 => ({ ...s1, publicationLibrary: a(s1.publicationLibrary) })),
        ...s.blocks
          .filterNot(b => b.kind == 'headerBlock')
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' &&
      s.page.value.extra_data.post.template == 'webinars-overview') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        ...s.blocks
        .filterNot(b => b.kind == 'headerBlock')
        .map((b, index) => render_block(b, index))
        .valueSeq()
        .toArray(),
        WebinarsOverviewWidget(s).map(a => s1 => ({ ...s1, webinarsOverview: a(s1.webinarsOverview) }))
      ])
    }

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' &&
      s.page.value.extra_data.post.template == 'conferences-overview') {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        render_block(header, s.blocks.keyOf(header)),
        ...s.blocks
        .filterNot(b => b.kind == 'headerBlock')
        .map((b, index) => render_block(b, index))
        .valueSeq()
        .toArray(),
        ConferencesOverviewWidget(s).map(a => s1 => ({ ...s1, conferencesOverview: a(s1.conferencesOverview) }))
      ])
    }

    return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
      ...s.blocks
        .map((b, index) => render_block(b, index))
        .valueSeq()
        .toArray()
    ])
  }
}

export let pageDisplay = (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
): ((
  b: (Block | CustomBlock)[],
  public_state: PublicSiteState
) => IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
>) => (b, public_state) => pageDisplay_AUX(b, blocks_renderer, public_state)
